interface FormatNameArgs {
  firstName?: string;
  lastName?: string;
}
export const formatName = ({ firstName, lastName }: FormatNameArgs) => {
  const nameArr = [firstName, lastName];
  return nameArr.some(Boolean) ? nameArr.filter(Boolean).join(' ') : '';
};
